import {forEach, isEmpty} from 'lodash'
import {getManifestItemForDocItem} from 'powtoon-document/manifest'
import {createValidationForSchema} from '../../utils/ajvValidation'
import {validate as powtoonValidate} from '../../utils/powtoonValidation'
import schema from './schema/01.07.schema.json'
import {isDecimalInteger} from 'powtoon-commons/utils/numbers'

let ajvValidate = null

export function initValidate ()  {
  if (!ajvValidate){
    ajvValidate = createValidationForSchema(schema, {strict: false})
  }
}

export const validate = async (powtoon,
  {
    strictMode = false,
    ignoreManifest = false,
    isValidTime = isDecimalInteger,
    getMinTimeStep
  } = {}) => {
  const powtoonValidationErrors = powtoonValidate(powtoon, {strictMode, ignoreManifest, isValidTime, getMinTimeStep})

  let powtoonForAjv = powtoon
  if (ignoreManifest) {
    powtoonForAjv = {...powtoon}
    delete(powtoonForAjv.manifest)
  }
  if (!ajvValidate){
    initValidate()
  }
  const ajvValidationErrors = ajvValidate (powtoonForAjv)

  if (!powtoonValidationErrors) {
    return ajvValidationErrors
  }

  if (!ajvValidationErrors) {
    return powtoonValidationErrors
  }

  return {
    errors: [...powtoonValidationErrors.errors, ...ajvValidationErrors.errors],
    // eslint-disable-next-line max-len
    errorMessage: `POWTOON VALIDATION:\n-------------------\n\n${powtoonValidationErrors.errorMessage}\n\nSCHEMA VALIDATION:\n------------------\n\n${ajvValidationErrors.errorMessage}`
  }
}

function updateAudioTracks(audioTracks, manifest, slideDuration = 0) {
  forEach(audioTracks, audioTrack => {
    if (audioTrack && !audioTrack.playbackSettings) {
      const {length} = getManifestItemForDocItem(manifest, audioTrack) || {length: slideDuration}
      const baseVolume = audioTrack.baseVolume
      delete audioTrack.baseVolume
      if (slideDuration) {
        audioTrack.startTime = 0
        audioTrack.endTime = slideDuration
      }
      audioTrack.enterEffect = 'None'
      audioTrack.exitEffect = 'None'
      audioTrack.playbackSettings = {
        baseVolume,
        startTime: 0,
        endTime: slideDuration ? Math.min(slideDuration, length) : length
      }
    }
  })
}

export function updatePowtoonContent(content) {
  forEach(content.powtoon.slides, slide => {
    if (!isEmpty(slide.audioTracks)) {
      if (slide.audioTracks?.[0] === null) {
        delete slide.audioTracks
      }
      else {
        updateAudioTracks(slide.audioTracks, content.powtoon.manifest, slide.duration)
      }
    }
  })

  updateAudioTracks(content.powtoon.audioTracks, content.powtoon.manifest)
}
